import speakingurl from 'speakingurl'
import Project from './Project'

export const POWER_PROJECT_TYPES = {
  'Solar': {
    'icon': 'flaticon-sun',
    'key': 'Solar',
    'shortName': 'Solar'
  },
  'Hydroelectric': {
    'icon': 'flaticon-raindrops',
    'key': 'Hydroelectric',
    'shortName': 'Hydro'
  },
  'Wind': {
    'icon': 'flaticon-windmill',
    'key': 'Wind',
    'shortName': 'Wind'
  },
  'Biomass': {
    'icon': 'flaticon-biomass',
    'key': 'Biomass',
    'shortName': 'Biomass'
  },
  'Tidal': {
    'icon': 'flaticon-sea',
    'key': 'Tidal',
    'shortName': 'Tidal'
  },
  'Pumped Storage': {
    'icon': 'flaticon-hydraulic-energy',
    'key': 'Pumped Storage',
    'shortName': 'Pumped'
  },
  'Other': {
    'icon': 'flaticon-package',
    'key': 'Other',
    'shortName': 'Other'
  }
}

export const POWER_TOTAL = 'Total'

class PowerProject extends Project {
  constructor (obj) {
    super(obj)

    // Name and facility details
    this.name = obj.Facility
    this.owner = obj.Owner
    this.operator = obj.Operator
    this.id = speakingurl(`${this.name}-${this.owner}`)

    this.city = obj.City
    this.renewableMW = +obj.Renew_MW
    this.renewableType = obj.PrimRenew
    this.renewableTypeShortName = POWER_PROJECT_TYPES[this.renewableType].shortName
    this.icon = POWER_PROJECT_TYPES[this.renewableType].icon
  }

  static emptyProjectTypes () {
    return JSON.parse(JSON.stringify(POWER_PROJECT_TYPES))
  }

  URL () {
    return `/power-projects/${this.id}`
  }
}

export default PowerProject



// WEBPACK FOOTER //
// ./src/models/PowerProject.js